import {Provider} from '@radix-ui/react-toast';

type Props = React.ComponentPropsWithRef<typeof Provider>;
export function ToastProvider(props: Props): React.JSX.Element {
  return <Provider {...props} swipeDirection="right" />;
}

ToastProvider.displayName = 'ToastProvider';
